import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import MainDashboard from "../pages/Dasboard/MainDashboard";
import AppointmentRequest from "../pages/Appointment/AppointmentRequest";
import AppointmentSchedule from "../pages/Appointment/AppointmentSchedule";
import VisitConfirmation from "../pages/Appointment/VisitConfirmation";
import TokenGeneration from "../pages/Appointment/TokenGeneration";
import AppointmentFixed from "../pages/Appointment/AppointmentFixed";
import AppointmentCompleted from "../pages/Appointment/AppointmentCompleted";
import CreateAppointment from "../pages/Appointment/CreateAppointment";
import TvScreen from "../pages/SuperAdminPages/PanditJiScreen";
function AuthenticatedRoutes() {
  return (
    <Routes>
      {/* Dashboard Routes Statred */}
      <Route path="/" element={<MainDashboard/>} />
      {/* Dashboard Routes Ended */}

      {/* Appointment Route Started */}
      <Route path="/appointment-request" element={<AppointmentRequest />} />
      <Route path="/appointment-schedule" element={<AppointmentSchedule />} />
      <Route path="/visit-confirmation" element={<VisitConfirmation />} />
      <Route path="/appointment-fixed" element={<AppointmentFixed />} />
      <Route path="/appointment-completed" element={<AppointmentCompleted />} />
      <Route path="/create-appointment" element={<CreateAppointment />} />
      <Route path="/tv-screen" element={<TvScreen/>} />
      {/* Appointment Route Ended */}
    </Routes>
  );
}

export default AuthenticatedRoutes;
